import { useState, useEffect } from 'react';

export type FontSizeOption = 'small' | 'normal' | 'large' | 'xlarge';

const FONT_SIZE_KEY = 'ecregi_font_size';

export function getStoredFontSize(): FontSizeOption {
  if (typeof window === 'undefined') return 'normal';
  try {
    const val = localStorage.getItem(FONT_SIZE_KEY) as FontSizeOption | null;
    if (val && ['small', 'normal', 'large', 'xlarge'].includes(val)) {
      return val;
    }
  } catch (e) {
    // Ignore localStorage access errors
  }
  return 'normal';
}

export function applyFontSize(size: FontSizeOption) {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-font-size', size);
  try {
    localStorage.setItem(FONT_SIZE_KEY, size);
  } catch (e) {
    // Ignore localStorage write errors
  }
}

// Auto-apply stored font size on script execution
if (typeof window !== 'undefined') {
  applyFontSize(getStoredFontSize());
}

export function useFontSize() {
  const [fontSize, setFontSizeState] = useState<FontSizeOption>(getStoredFontSize);

  useEffect(() => {
    applyFontSize(fontSize);
  }, [fontSize]);

  const setFontSize = (size: FontSizeOption) => {
    setFontSizeState(size);
    applyFontSize(size);
  };

  return { fontSize, setFontSize };
}
